import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

@Injectable()
export class JackpotService {

    private jackpots: BehaviorSubject<{common: any, local: any, localPlayer: any}> = new BehaviorSubject(null);
    private jackpotWins: BehaviorSubject<any[]> = new BehaviorSubject(null);

    constructor() {
    }


    get isJackpotEnabled() {
        return !!this.jackpots.getValue();
    }

    get getJackpots() {
        return this.jackpots.asObservable();
    }

    get getJackpotWins() {
        return this.jackpotWins.asObservable();
    }

    setJackpots(jackpotData) {
        if ((Array.isArray(jackpotData) && jackpotData.length <= 0) || (typeof jackpotData === 'object') && (!jackpotData)
            || ((!jackpotData.common.status) && (!jackpotData.local.status) && (!jackpotData.localPlayer.status)) ) {
            this.jackpots.next(null);
        } else {
            this.jackpots.next(jackpotData);
        }
    }
    setJackpotWins(jackpotWins) {
        if ((Array.isArray(jackpotWins) && jackpotWins.length <= 0) || (typeof jackpotWins === 'object') && (!jackpotWins)) {
            this.jackpotWins.next(null);
        } else {
            this.jackpotWins.next(jackpotWins);
        }
    }
}



// WEBPACK FOOTER //
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/app/Modules/Shared/services/jackpot.service.ts